import { render, staticRenderFns } from "./Uniforme.vue?vue&type=template&id=b0724090&scoped=true&"
import script from "./Uniforme.vue?vue&type=script&lang=js&"
export * from "./Uniforme.vue?vue&type=script&lang=js&"
import style0 from "./Uniforme.vue?vue&type=style&index=0&id=b0724090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0724090",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
